import React from 'react';
import SliderComponent from './SliderComponent';


export default function Home() {
  return (
    <>
      <SliderComponent />

    <section className="container-wrapper">
      <h2>Welcome to BridgingSkilled</h2>
      <p>At BridgingSkilled, we believe that learning should not just prepare you for today but empower you for tomorrow.</p>
    <p>Our mission is to transform education into a <strong>skill-driven journey</strong> where every learner gains the confidence, knowledge, and hands-on expertise needed to thrive in the IT industry.</p>

    <h2>Why Choose BridgingSkilled?</h2>
    <p><strong>Practical Learning</strong> – Learn by doing with live projects and real-world case studies.</p>
    <p><strong>Industry-Relevant Courses</strong> – Stay ahead with programs designed by experts in line with the latest technologies.</p>
    <p><strong>Flexible Training</strong> – Whether you’re a student, fresher, or working professional, we provide learning that fits your schedule.</p>
    <p><strong>Career Growth Focused</strong> – We don’t just train; we prepare you to be job-ready with skills employers value.</p>
    <h2>Explore Our Courses</h2>
    <p>We provide a wide range of courses designed for beginners and advanced learners alike:</p>
    <p><strong>Web Development (HTML, CSS, JavaScript, React, MERN/MEAN)</strong></p>
    <p><strong>Cloud & DevOps (AWS, Azure, Docker, Kubernetes)</strong></p>
    <p><strong>Programming (Python, Java, C, C++)</strong></p>
    <p><strong>CAD Designs(AutoCad, Catia, Solid Works)</strong></p>
    </section>
  </>
  );
}

